module.exports = __webpack_public_path__ + "img/logo_cnfcu.edc44e0d.png";